import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://api.falcontranslation.co.uk/api",
});

export const useApi = (endpoint, method = "GET", isMultipart = false) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data) => {
      const headers = isMultipart
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" };

      const response = await apiClient({
        url: endpoint,
        method,
        data,
        headers,
      });
      return response.data;
    },
    {
      onError: (error) => {
        console.error("API Error:", error);
      },
      onSuccess: () => {
        queryClient.invalidateQueries([endpoint]);
      },
    }
  );

  return mutation;
};
